import { useEffect } from 'react';
import StoreMappingGrid from '..//StoreMappingGrid';
import { useFormContext, useWatch } from 'react-hook-form';
import { StoreTargetMapping } from '../../../models/storetarget';
import { NewCampaignStore } from '../../../models/campaign';

interface Props {
  setAssignStoresComplete: React.Dispatch<React.SetStateAction<boolean>>;
  stores: NewCampaignStore[];
  isEditMode: boolean;
}

export default function MapStoresStep({
  setAssignStoresComplete,
  stores,
  isEditMode,
}: Props) {
  const { control } = useFormContext();
  const propertyName = useWatch({
    control,
    name: 'propertyName',
  });

  const StoreTargetMappings = useWatch({
    control,
    defaultValue: [],
    name: 'StoreTargetMappings',
  });

  useEffect(() => {
    if (StoreTargetMappings.length === 0) return;

    const allMapped = (StoreTargetMappings as StoreTargetMapping[]).every(
      (mapping) => mapping.propertyValue && mapping.propertyValue.trim() !== '',
    );
    setAssignStoresComplete(allMapped);
  }, [StoreTargetMappings]);

  return (
    <div className="flex min-h-[560px] w-full flex-col gap-6 p-10">
      <div className="flex flex-col gap-1">
        <div className="flex gap-1">
          <p className="text-lg">Assign Stores to</p>
          <p className="text-lg font-semibold">{propertyName}</p>
        </div>
        <p className="text-muted-foreground text-sm">
          Select stores and assign them to each store group.
        </p>
      </div>

      <StoreMappingGrid data={stores} isEditMode={isEditMode} />
    </div>
  );
}
